<template>
  <div>
    <BreadCrumb
      :breadCrumbList="breadCrumbList"
      class="breadCrumb"
    ></BreadCrumb>
  </div>
</template>

<script>
import BreadCrumb from '@/components/Shared/BreadCrumb/BreadCrumbTemplate'
import { getters as currentAdvertiserGetters } from '@/vuex/modules/currentAdvertiser/constants'
import { getters as currentAgencyGetters } from '@/vuex/modules/currentAgency/constants'

export default {
  name: 'PointGroupOperationBreadCrumb',
  components: { BreadCrumb },
  computed: {
    breadCrumbList() {
      const self = { title: '地点編集', path: null }
      if (this.agencyId == null) return [self]
      return [
        {
          title: '地点管理リスト',
          path: `/agencies/${this.agencyId}/advertisers/${
            this.advertiserId
          }/point_groups`,
        },
        self,
      ]
    },
    agencyId() {
      return this.$store.getters[currentAgencyGetters.currentAgencyId]
    },
    advertiserId() {
      return this.$store.getters[currentAdvertiserGetters.currentAdvertiserId]
    },
  },
}
</script>

<style scoped></style>
